export default "__VITE_ASSET__Cr1v9shx__"